import { ApiUrl } from "../utils/modules";
import axios from "axios";

class JournalServices {
constructor(api) {
this.api = api;
  }

getAll() {
return this.api.get(ApiUrl + "journal/all");
  }

getOne(id) {
return this.api.get(ApiUrl + "journal/" + id);
  }

create(data) {
return this.api.post(ApiUrl + "journal", data);
  }

update(id, data) {
return this.api.put(ApiUrl + "journal/" + id, data);
  }
}

export default JournalServices;